
import { Routes } from "@angular/router";
import { RolePermissionGuard } from "../guard/role-permission.guard";
export const content: Routes = [
  {
    path: "dashboard",
    loadChildren: () => import("../../components/dashboard/dashboard.module").then((m) => m.DashboardModule),
  },
  {
    path: "widgets",
    loadChildren: () => import("../../components/widgets/widgets.module").then((m) => m.WidgetsModule),
  },
  {
    path: "ui-kits",
    loadChildren: () => import("../../components/ui-kits/ui-kits.module").then((m) => m.UiKitsModule),
  },
  {
    path: "base",
    loadChildren: () => import("../../components/bonus-ui/base/base.module").then((m) => m.BaseModule),
  },
  {
    path: "advance",
    loadChildren: () => import("../../components/bonus-ui/advance/advance.module").then((m) => m.AdvanceModule),
  },
  {
    path: "project",
    loadChildren: () => import("../../components/apps/project/project.module").then((m) => m.ProjectModule),
  },
  {
    path: "personas",
    loadChildren: () => import("../../components/personas/personas.module").then((m) => m.PersonasModule),
    canActivate: [RolePermissionGuard],
    data: { permisos: ["personas.listar"] }
  },
  {
    path: "cargos",
    loadChildren: () => import("../../components/personas/cargos/cargos.module").then((m) => m.CargosModule)
  },

  {
    path: "clasificaciones",
    loadChildren: () => import("../../components/personas/clasificaciones/clasificaciones.module").then((m) => m.ClasificacionesModule)
  },
  {
    path: "peligros",
    loadChildren: () => import("../../components/personas/peligros/peligros.module").then((m) => m.PeligrosModule)
  },
  {
    path: "profesiogramas",
    loadChildren: () => import("../../components/personas/examenes-medicos/profesiogramas/profesiogramas.module").then((m) => m.ProfesiogramasModule)
  },
  {
    path: "profesiograma-peligros",
    loadChildren: () => import("../../components/personas/examenes-medicos/profesiograma-peligros/profesiograma-peligros.module").then((m) => m.ProfesiogramaPeligrosModule)
  },
  {
    path: "profesiograma-cargos",
    loadChildren: () => import("../../components/personas/examenes-medicos/profesiograma-cargos/profesiograma-cargos.module").then((m) => m.ProfesiogramaCargosModule)
  },
  {
    path: "tipos-examen",
    loadChildren: () => import("../../components/personas/examenes-medicos/tipos-examen/tipos-examen.module").then((m) => m.TiposExamenModule)
  },
  {
    path: "examenes",
    loadChildren: () => import("../../components/personas/examenes-medicos/examenes/examenes.module").then((m) => m.ExamenesModule)
  },
  {
    path: "profesiograma-examenes",
    loadChildren: () => import("../../components/personas/examenes-medicos/profesiograma-examenes/profesiograma-examenes.module").then((m) => m.ProfesiogramaExamenesModule)
  },
  {
    path: "capacitacion-catalogo",
    loadChildren: () => import("../../components/personas/capacitaciones/capacitacion-catalogo/capacitacion-catalogo.module").then((m) => m.CapacitacionCatalogoModule)
  },
  {
    path: "capacitacion-programacion",
    loadChildren: () => import("../../components/personas/capacitaciones/capacitaciones-programacion/capacitaciones-programacion.module").then((m) => m.CapacitacionesProgramacionModule)
  },
  {
  path: "personas/nueva",
  loadChildren: () => import("../../components/personas/personas.module").then((m) => m.PersonasModule),
  canActivate: [RolePermissionGuard],
  data: { permisos: ["personas.crear"] }
},
  {
    path: "administracion",
    loadChildren: () => import("../../components/administracion/administracion.module").then((m) => m.AdministracionModule),
    canActivate: [RolePermissionGuard],
    data: { permisos: ["administracion.ver"] }
  },
  
  {
    path: "listados",
    loadChildren: () => import("../../components/personas/listados/listados.module").then((m) => m.ListadosModule),
    canActivate: [RolePermissionGuard],
    data: { permisos: ["personas.listado_activos"] }
  },
  {
    path: "licencia",
    loadChildren: () => import("../../components/personas/licencia/licencia.module").then((m) => m.LicenciaModule),
    canActivate: [RolePermissionGuard],
    data: { permisos: ["personas.licencias"] }
  },
  {
    path: "multas",
    loadChildren: () => import("../../components/personas/multas/multas.module").then((m) => m.MultasModule),
    canActivate: [RolePermissionGuard],
    data: { permisos: ["personas.multas"] }
  },
  {
    path: "medicos",
    loadChildren: () => import("../../components/personas/medicos/medicos.module").then((m) => m.MedicosModule),
    canActivate: [RolePermissionGuard],
    data: { permisos: ["personas.soportes"] }
  },
  {
    path: "cartas",
    loadChildren: () => import("../../components/vehiculos/cartas/cartas.module").then((m) => m.CartasModule),
    canActivate: [RolePermissionGuard],
    data: { permisos: ["vehiculos.cartas"] }
  },
  {
    path: "cumpleanos",
    loadChildren: () => import("../../components/personas/cumpleanos/cumpleanos.module").then((m) => m.CumpleanosModule),
    canActivate: [RolePermissionGuard],
    data: { permisos: ["personas.cumpleanios"] }
  },
  {
    path: "vehiculos",
    loadChildren: () => import("../../components/vehiculos/nuevo/nuevo.module").then((m) => m.NuevoModule),
    canActivate: [RolePermissionGuard],
    data: { permisos: ["vehiculos.crear"] }
  },
  {
    path: "afiliados-activos",
    loadChildren: () => import("../../components/vehiculos/afiliados-activos/afiliados-activos.module").then((m) => m.AfiliadosActivosModule),
    canActivate: [RolePermissionGuard],
    data: { permisos: ["vehiculos.listar_activas"] }
  },
  {
    path: "terceros-activos",
    loadChildren: () => import("../../components/vehiculos/terceros-activos/terceros-activos.module").then((m) => m.TercerosActivosModule),
     canActivate: [RolePermissionGuard],
    data: { permisos: ['vehiculos.listarTerceros'] } // 👈 permiso requerido
  },
  {
    path: "inactivos",
    loadChildren: () => import("../../components/vehiculos/inactivos/inactivo.module").then((m) => m.InactivoModule),
    canActivate: [RolePermissionGuard],
    data: { permisos: ["vehiculos.listar_inactivas"] }
  },
  {
    path: "particular",
    loadChildren: () => import("../../components/vehiculos/particular/particular.module").then((m) => m.ParticularModule),
    canActivate: [RolePermissionGuard],
    data: { permisos: ["vehiculos.listarParticulares"] }
  },
  {
    path: "digitales-empresa",
    loadChildren: () => import("../../components/comercial/empresas/digitales/digitales-empresas.module").then((m) => m.DigitalesEmpresasModule),
  },
  {
    path: "general",
    loadChildren: () => import("../../components/vehiculos/general/general.module").then((m) => m.GeneralModule),
    canActivate: [RolePermissionGuard],
    data: { permisos: ["vehiculos.listaGeneral"] }
  },
  {
    path: "documentos",
    loadChildren: () => import("../../components/vehiculos/documentos/documentos.module").then((m) => m.DocumentosModule),
    canActivate: [RolePermissionGuard],
    data: { permisos: ["vehiculos.documentos"] }
  },
  
  {
    path: "listado-marcas",
    loadChildren: () => import("../../components/vehiculos/marcas/listado/listado.module").then((m) => m.ListadoModule),
  },
  {
    path: "marcas-inactivas",
    loadChildren: () => import("../../components/vehiculos/marcas/marcas-inactivas/marcas-inactivas.module").then((m) => m.MarcasInactivasModule),
  },
 
  {
    path: "listado-modelo",
    loadChildren: () => import("../../components/vehiculos/modelo/listado/listado-modelo.module").then((m) => m.ListadoModeloModule),
  },
  {
    path: "rodamientos",
    loadChildren: () => import("../../components/vehiculos/rodamientos/rodamientos.module").then((m) => m.RodamientosModule),
    canActivate: [RolePermissionGuard],
    data: { permisos: ["vehiculos.ver"] }
  },
  {
    path: "modelo-inactivo",
    loadChildren: () => import("../../components/vehiculos/modelo/modelo-inactivo/modelo-inactivo.module").then((m) => m.ModeloInactivoModule),
  },
  {
    path: "alistamientos-diarios",
    loadChildren: () => import("../../components/vehiculos/alistamientos-diarios/alistamientos-diarios.module").then((m) => m.AlistamientosDiariosModule),
  },
  {
    path: "polizas",
    loadChildren: () => import("../../components/vehiculos/polizas/polizas.module").then((m) => m.PolizasModule),
  },
  {
    path: "conductores-asignados",
    loadChildren: () => import("../../components/vehiculos/conductores/conductores.module").then((m) => m.ConductoresModule),
  },
  {
    path: "Listado-siniestros-viales",
    loadChildren: () => import("../../components/vehiculos/siniestros-Viales/listado/siniestros-viales.module").then((m) => m.SiniestrosVialesModule),
  },
  {
    path: "siniestros-viales-crear",
    loadChildren: () => import("../../components/vehiculos/siniestros-Viales/siniestros-viales-crear/siniestros-viales-crear.module").then((m) => m.SiniestrosVialesCrearModule),
  },
  {
    path: "editar",
    loadChildren: () => import("../../components/vehiculos/siniestros-Viales/editar-siniestro/editar-siniestro.module").then((m) => m.EditarSiniestroModule),
  },
  {
    path: "vehiculo",
    loadChildren: () => import("../../components/vehiculos/afiliados-activos/afiliados-activos/editar-vehiculo/editar-vehiculo.module").then((m) => m.EditarVehiculoModule),
  },
  {
    path: "inspeccion-vehiculos",
    loadChildren: () => import("../../components/pesv/implementacion/inspeccion-vehiculos/inspeccion-vehiculos.module").then((m) => m.InspeccionVehiculosModule),
  },
  {
    path: "elaborar",
    loadChildren: () => import("../../components/extractos/elaborar/elaborar.module").then((m) => m.ElaborarModule),
  },
  {
    path: "listado-extractos",
    loadChildren: () => import("../../components/extractos/listado-extractos/listado-extractos.module").then((m) => m.ListadoExtractosModule),
  },
  {
    path: "consultar",
    loadChildren: () => import("../../components/extractos/consultar/consultar.module").then((m) => m.ConsultarModule),
  },
  {
    path: "contratos",
    loadChildren: () => import("../../components/extractos/contratos/contratos.module").then((m) => m.ContratosModule),
  },
  {
    path: "crear",
    loadChildren: () => import("../../components/extractos/rutas/crear/crear.module").then((m) => m.CrearModule),
  },
  {
    path: "listado-rutas",
    loadChildren: () => import("../../components/extractos/rutas/listado-rutas/listado-rutas.module").then((m) => m.ListadoRutasModule),
  },
  {
    path: "crear-departamento",
    loadChildren: () => import("../../components/extractos/departamentos/crear-departamento.module").then((m) => m.CrearDepartamentoModule),
  },
  {
    path: "listado-departamento",
    loadChildren: () => import("../../components/extractos/departamentos/listado-departamento/listado-departamento.module").then((m) => m.ListadoDepartamentoModule),
  },
  {
    path: "nueva-empresa",
    loadChildren: () => import("../../components/comercial/empresas/nueva-empresa/nueva-empresa.module").then((m) => m.NuevaEmpresaModule),
  },
  {
    path: "empresas-activas",
    loadChildren: () => import("../../components/comercial/empresas/empresas-activas/empresas-activas.module").then((m) => m.EmpresasActivasModule),
  },

  {
    path: "empresas-inactivas",
    loadChildren: () => import("../../components/comercial/empresas/empresas-inactivas/empresas-inactivas.module").then((m) => m.EmpresasInactivasModule),
  },
  {
    path: "nuevo-cotizaciones",
    loadChildren: () => import("../../components/comercial/cotizaciones/nuevo-cotizaciones/nuevo-cotizaciones.module").then((m) => m.NuevoCotizacionesModule),
  },
  {
    path: "activos-cotizaciones",
    loadChildren: () => import("../../components/comercial/cotizaciones/activos-cotizaciones/activos-cotizaciones.module").then((m) => m.ActivosCotizacionesModule),
  },
  {
    path: "cerradas-cotizaciones",
    loadChildren: () => import("../../components/comercial/cotizaciones/cerradas-cotizaciones/cerradas-cotizaciones.module").then((m) => m.CerradasCotizacionesModule),
  },
  {
    path: "general-cotizaciones",
    loadChildren: () => import("../../components/comercial/cotizaciones/general-cotizaciones/general-cotizaciones.module").then((m) => m.GeneralCotizacionesModule),
  },
  {
    path: "registrar",
    loadChildren: () => import("../../components/mantenimientos/registrar/registrar-routing.module").then((m) => m.RegistrarRoutingModule),
  },
  {
    path: "registrar-pesv",
    loadChildren: () => import("../../components/pesv/registrar/registrar-routing.module").then((m) => m.RegistrarRoutingModule),
  },
  {
    path: "comite",
    loadChildren: () => import("../../components/pesv/listado-pesv/listado-pesv-routing.module").then((m) => m.ListadoPesvRoutingModule),
  },
  {
    path: "plan-anual/plan-anual",
    loadChildren: () => import("../../components/pesv/plan-anual/plan-anual-routing.module").then((m) => m.PlanAnualRoutingModule),
  },
  {
    path: "gestion-plan/gestion-plan",
    loadChildren: () => import("../../components/pesv/plan-anual/gestion-plan/gestion-plan.module").then((m) => m.GestionPlanModule),
  },
  {
    path: "pasos-plan/pasos-plan/:id",
    loadChildren: () => import("../../components/pesv/plan-anual/pasos-plan/pasos-plan.module").then((m) => m.PasosPlanModule),
  },
  {
    path: "gestión-general/gestión-general/:id",
    loadChildren: () => import("../../components/pesv/plan-anual/gestion-general/gestion-general.module").then((m) => m.GestionGeneralModule),
  },
  {
    path: "competencia-plan-anual",
    loadChildren: () => import("../../components/pesv/competencia-plan-anual/competencia-plan-anual.module").then((m) => m.CompetenciaPlanAnualModule),
  },
  {
    path: "liderazgo-compromiso",
    loadChildren: () => import("../../components/pesv/liderazgo-compromiso/liderazgo-compromiso-routing.module").then((m) => m.LiderazgoCompromisoRoutingModule),
  },
  {
    path: "diagnostico-pesv",
    loadChildren: () => import("../../components/pesv/diagnostico/diagnostico-routing.module").then((m) => m.DiagnosticoPesvRoutingModule),
  },
  {
    path: "pesv-digitales",
    loadChildren: () => import("../../components/digitales-pesv/digitales-pesv-routing.module").then((m) => m.DigitalesPesvRoutingModule),
  },
  {
    path: "politica-seguridad-vial",
    loadChildren: () => import("../../components/pesv/politica-seguridad-vial/politica-seguridad-vial-routing.module").then((m) => m.PoliticaSeguridadVialRoutingModule),
  },
  {
    path: "objetivo-metas",
    loadChildren: () => import("../../components/pesv/objetivo-metas/objetivo-metas.module").then((m) => m.ObjetivoMetasModule),
  },
   {
    path: "listado/metas",
    loadChildren: () => import("../../components/pesv/objetivo-metas/metas-indicador/metas-indicador.module").then((m) => m.MetasIndicadorModule),
  },
  {
    path: "riesgos-viales",
    loadChildren: () => import("../../components/pesv/riesgos_viales/riesgos-viales-routing.module").then((m) => m.RiesgosVialesRoutingModule),
  },
  {
    path: "riesgo-vial",
    loadChildren: () => import("../../components/pesv/riesgos_viales/plan-accion/plan-accion.module").then((m) => m.PlanAccionModule),
  },
  {
    path: "programa-pesv",
    loadChildren: () => import("../../components/pesv/programas-gestion/programas-gestion/programas-gestion-routing.module").then((m) => m.ProgramasGestionRoutingModule),
  },
  {
    path: "programas-gestion",
    loadChildren: () => import("../../components/pesv/programas-gestion/programas-gestion/programas-gestion.module").then((m) => m.ProgramasGestionModule),
  },
  {
    path: "ordenes",
    loadChildren: () => import("../../components/mantenimientos/ordenes/ordenes.module").then((m) => m.OrdenesModule),
  },
  {
    path: "listado-mantenimientos",
    loadChildren: () => import("../../components/mantenimientos/listado-mantenimientos/listado-mantenimientos.module").then((m) => m.ListadoMantenimientosModule),
  },
  {
    path: "combustible",
    loadChildren: () => import("../../components/mantenimientos/combustible/combutible-routing.module").then((m) => m.CombutibleRoutingModule),
  },
  {
    path: "consultar-combustible",
    loadChildren: () => import("../../components/mantenimientos/consultar-combustible/consultar-combustible.module").then((m) => m.ConsultarCombustibleModule),
  },
  {
    path: "persona",
    loadChildren: () => import("../../components/personas/personas/editar/editar.module").then((m) => m.EditarModule),
  },
  {
    path: "digitales",
    loadChildren: () => import("../../components/personas/personas/digitales/digitales.module").then((m) => m.DigitalesModule),
  },  
  {
    path: "Extractos",
    loadChildren: () => import("../../components/extractos/elaborar/elaborar/crear-extracto/crear-extracto.module").then((m) => m.CrearExtractoModule),
  },
   {
    path: "digital",
    loadChildren: () => import("../../components/vehiculos/digitales/digitales.module").then((m) => m.DigitalModule),
  },
  {
    path: "enviar",
    loadChildren: () => import("../../components/notificaciones/enviar/enviar.module").then((m) => m.EnviarModule),
  },
  {
    path: "rutas-inactivas",
    loadChildren: () => import("../../components/extractos/rutas/rutas-inactivas/rutas-inactivas.module").then((m) => m.RutasInactivasModule),
  },
  {
    path: "departamentos-inactivos",
    loadChildren: () => import("../../components/extractos/departamentos/departamentos-inactivos/departamentos-inactivos.module").then((m) => m.DepartamentosInactivosModule),
  },
  {
    path: "usuarios-app",
    loadChildren: () => import("../../components/usuarios/usuarios-app/usuarios-app.module").then((m) => m.UsuariosAppModule),
  },
  {
    path: "web",
    loadChildren: () => import("../../components/usuarios/web/web.module").then((m) => m.WebModule),
  },
  {
    path: "ejecutadas",
    loadChildren: () => import("../../components/usuarios/ejecutadas/ejecutadas.module").then((m) => m.EjecutadasModule),
  },
  {
    path: "ecommerce",
    loadChildren: () => import("../../components/apps/e-commerce/e-commerce.module").then((m) => m.ECommerceModule),
  },
  {
    path: "email",
    loadChildren: () => import("../../components/apps/email/email.module").then((m) => m.EmailModule),
  },
  {
    path: "chat",
    loadChildren: () => import("../../components/apps/chat/chat.module").then((m) => m.ChatModule),
  },
  {
    path: "user",
    loadChildren: () => import("../../components/apps/users/users.module").then((m) => m.UsersModule),
  },
  {
    path: "bookmarks",
    loadChildren: () => import("../../components/apps/bookmarks/bookmarks.module").then((m) => m.BookmarksModule),
  },
  {
    path: "file-manager",
    loadChildren: () => import("../../components/apps/file-manager/file-manager.module").then((m) => m.FileManagerModule),
  },
  {
    path: "contacts",
    loadChildren: () => import("../../components/apps/contacts/contacts.module").then((m) => m.ContactsModule),
  },
  {
    path: "tasks",
    loadChildren: () => import("../../components/apps/tasks/tasks.module").then((m) => m.TasksModule),
  },
  {
    path: "calender",
    loadChildren: () => import("../../components/apps/calender/calender.module").then((m) => m.CalenderModule),
  },
  {
    path: "social-app",
    loadChildren: () => import("../../components/apps/social-app/social-app.module").then((m) => m.SocialAppModule),
  },
  {
    path: "todo",
    loadChildren: () => import("../../components/apps/todo/todo.module").then((m) => m.TodoModule),
  },
  {
    path: "buttons",
    loadChildren: () => import("../../components/buttons/buttons.module").then((m) => m.ButtonsModule),
  },
  {
    path: "editor",
    loadChildren: () => import("../../components/editors/editor.module").then((m) => m.EditorModule),
  },
  {
    path: "chart",
    loadChildren: () => import("../../components/charts/charts.module").then((m) => m.ChartModule),
  },
  {
    path: "icons",
    loadChildren: () => import("../../components/icons/icons.module").then((m) => m.IconsModule),
  },
  {
    path: "form",
    loadChildren: () => import("../../components/forms/forms.module").then((m) => m.FormModule),
  },
  {
    path: "table",
    loadChildren: () => import("../../components/table/table.module").then((m) => m.TableModule),
  },
  {
    path: "cards",
    loadChildren: () => import("../../components/cards/cards.module").then((m) => m.CardsModule),
  },
  {
    path: "sample-page",
    loadChildren: () => import("../../components/others/sample/sample.module").then((m) => m.SampleModule),
  },
  {
    path: "gallery",
    loadChildren: () => import("../../components/apps/gallery/gallery.module").then((m) => m.GalleryDemoModule),
  },
  {
    path: "blog",
    loadChildren: () => import("../../components/apps/blog/blog.module").then((m) => m.BlogModule),
  },
  {
    path: "faq",
    loadChildren: () => import("../../components/apps/faq/faq.module").then((m) => m.FaqModule),
  },
  {
    path: "job",
    loadChildren: () => import("../../components/apps/job-search/job-search.module").then((m) => m.JobSearchModule),
  },
  {
    path: "learning",
    loadChildren: () => import("../../components/apps/learning/learning.module").then((m) => m.LearningModule),
  },
  {
    path: "knowledgebase",
    loadChildren: () => import("../../components/apps/knowledge-base/knowledge-base.module").then((m) => m.KnowledgeBaseModule),
  },
  {
    path: "map",
    loadChildren: () => import("../../components/apps/map/map.module").then((m) => m.MapModule),
  },
  {
    path: "support-ticket",
    loadChildren: () => import("../../components/apps/support-ticket/support-ticket.module").then((m) => m.SupportTicketModule),
  },
  {
    path: "search-pages",
    loadChildren: () => import("../../components/others/search-result/search-result.module").then((m) => m.SearchResultModule),
  },
  {
    path: "reportes-gps",
     canActivate: [RolePermissionGuard],
    loadChildren: () => import("../../components/gps/reportes.module").then((m) => m.ReportesModule),
      data: { permisos: ["gps.reportes"] }
  },
  {
    path: "certificados-gps",
    canActivate: [RolePermissionGuard],
    loadChildren: () => import("../../components/gps/certificados-gps/certificados-gps.module").then((m) => m.CertificadosGpsModule),
    data: { permisos: ["gps.certificados_gps"] }
  },
  {
    path: "encuestas",
    loadChildren: () => import("../../components/comercial/encuestas/encuestas.module").then((m) => m.EncuestasModule),
  },
  {
    path: "vehiculos/actualizar-polizas",
    loadChildren: () => import("../../components/vehiculos/actualizar-polizas/actualizar-polizas.module").then(m => m.ActualizarPolizasModule),
    canActivate: [RolePermissionGuard],
    data: { permisos: ["vehiculos.actualizar_polizas"] }
  },
  {
    path: "mantenimientos",
    loadChildren: () => import("../../components/mantenimientos/plan-mantenimientos/plan-mantenimientos.module").then(m => m.PlanMantenimientosModule),
    canActivate: [RolePermissionGuard],
    data: { permisos: ["mantenimientos.crear_plan_mantenimientos"] }
  },

  {
    path: "mantenimientos/crear-actividades-mantenimientos",
    loadChildren: () => import("../../components/mantenimientos/plan-mantenimientos/crear-actividades-mantenimientos/crear-actividades-mantenimientos.module").then(m => m.CrearActividadesMantenimientosModule),
    canActivate: [RolePermissionGuard],
    data: { permisos: ["mantenimientos.crear_actividades_mantenimientos"] }
  },
  {
   path:"mantenimientos/programar-mantenimientos",
   loadChildren: () => import("../../components/mantenimientos/plan-mantenimientos/programacion-plan-mantenimientos/programacion-plan-mantenimientos.module").then(m => m.ProgramacionPlanMantenimientosModule),
   canActivate: [RolePermissionGuard],
   data: { permisos: ["mantenimientos.programar_mantenimientos"] }
  },
   {
    path: "seguimientos",
    loadChildren: () => import("../../components/pesv/programas-gestion/seguimientos/seguimientos.module").then((m) => m.SeguimientosModule),
  },
    

   {
    path: "listado/tipos-programa",
    loadChildren: () => import("../../components/pesv/programas-gestion/tipo-programa/tipo-programa.module").then((m) => m.TipoProgramaModule),
  },

  {
    path: "listado/programas-gestion",
    loadChildren: () => import("../../components/pesv/programas-gestion/programas-gestion/programas-gestion.module").then((m) => m.ProgramasGestionModule),
  },

{
    path: "gestion-competencias/gestion-competencias",
    loadChildren: () => import("../../components/pesv/competencia-plan-anual/gestion-competencias/gestion-competencias.module").then((m) => m.GestionCompetenciasModule),
  },

  {
    path: "competencias/competencias",
    loadChildren: () => import("../../components/pesv/competencia-plan-anual/competencia/competencia.module").then((m) => m.CompetenciaModule),
  },
  {
    path: "documentos-competencia/documentos-competencia",
    loadChildren: () => import("../../components/pesv/competencia-plan-anual/documentos-competencia/documentos-competencia.module").then((m) => m.DocumentosCompetenciaModule),
  },
  {
    path: "plan-competencia-anual/plan-competencia-anual",
    loadChildren: () => import("../../components/pesv/competencia-plan-anual/plan-competencia/plan-competencia.module").then((m) => m.PlanCompetenciaModule)
  },

  {
    path: "capacitacion-actividades",
    loadChildren: () => import("../../components/personas/capacitaciones/capacitaciones-programacion/capacitaciones-programacion/actividades/actividades.module").then((m) => m.ActividadesModule)
  },

  {
    path: "capacitacion/asistentes/:id",
    loadChildren: () => import("../../components/personas/capacitaciones/capacitaciones-programacion/capacitaciones-programacion/asistentes/asistentes.module").then((m) => m.AsistentesModule),
  },
  
  {
    path: "listado/programacion-mantenimientos",
    loadChildren: () => import("../../components/mantenimientos/programacion-mantenimientos/programacion-mantenimientos.module").then((m) => m.ProgramacionMantenimientosModule),
  },

  // Ruta quejas
  {
    path: "listado/quejas",
    loadChildren: () => import("../../components/pesv/responsabilidad-comportamiento/quejas/quejas.module").then((m) => m.QuejasModule),
  },
  // Ruta responsabilidades
  {
    path: "listado/responsabilidades",
    loadChildren: () => import("../../components/pesv/responsabilidad-comportamiento/responsabilidades/responsabilidades.module").then((m) => m.ResponsabilidadesModule),
  },
  // Ruta criterios de comportamiento
  {
    path: "listado/criterios",
    loadChildren: () => import("../../components/pesv/responsabilidad-comportamiento/criterios-comportamiento/criterios-comportamiento.module").then((m) => m.CriteriosComportamientoModule),
  },
  // Ruta evaluacion de comportamiento
  {
    path: "listado/evaluacion",
    loadChildren: () => import("../../components/pesv/responsabilidad-comportamiento/evaluacion-comportamiento/evaluacion-comportamiento.module").then((m) => m.EvaluacionComportamientoModule),
  },
  // Ruta seguimiento comportamiento vial
  {
    path: "listado/seguimiento-comportamiento-vial",
    loadChildren: () => import("../../components/pesv/responsabilidad-comportamiento/seguimiento-comportamiento-vial/seguimiento-comportamiento-vial.module").then((m) => m.SeguimientoComportamientoVialModule),
  },
  // Ruta tipo comportamiento
  {
    path: "listado/tipo-comportamiento",
    loadChildren: () => import("../../components/pesv/responsabilidad-comportamiento/tipo-comportamiento/tipo-comportamiento.module").then((m) => m.TipoComportamientoModule),
  },
  // Ruta aspectos comportamiento
  {
    path: "listado/aspectos-comportamiento",
    loadChildren: () => import("../../components/pesv/responsabilidad-comportamiento/aspectos-comportamiento/aspectos-comportamiento.module").then((m) => m.AspectosComportamientoModule),
  },
  // Ruta procedimientos de contratación
  {
    path: "listado/procedimiento-contratacion",
    loadChildren: () => import("../../components/pesv/responsabilidad-comportamiento/procedimientos-contratacion/procedimientos-contratacion.module").then((m) => m.ProcedimientosContratacionModule),
  },
  // Ruta requisitos
  {
    path: "listado/requisitos",
    loadChildren: () => import("../../components/pesv/responsabilidad-comportamiento/requisitos/requisitos.module").then((m) => m.RequisitosModule),
  },
  // Ruta documentos plan de respuesta
  {
    path: "listado/documentos-plan-respuesta",
    loadChildren: () => import("../../components/pesv/plan-preparacion-respuesta/documentos/documentos.module").then((m) => m.DocumentosModule),
  },
  // Ruta investigacion interna
  {
    path: "listado/investigacion",
    loadChildren: () => import("../../components/pesv/investigacion-interna/investigacion/investigacion.module").then((m) => m.InvestigacionModule),
  },
  // Ruta gestión investigación
  {
     path: "listado/gestión-investigacción/:id",
     loadChildren: () => import("../../components/pesv/investigacion-interna/gestion/gestion.module").then((m) => m.GestionModule),
  },
  // Ruta documentos investigación
  {
    path: "listado/documentos-investigacion",
    loadChildren: () => import("../../components/pesv/investigacion-interna/documentos-investigacion/documentos-investigacion.module").then((m) => m.DocumentosInvestigacionModule),
  },
  // Vias Zonas
  {
    path: "listado/vias-internas",
    loadChildren: () => import("../../components/pesv/vias-seguras-administradas/vias-internas/vias-internas.module").then((m) => m.ViasInternasModule)
  },
  // Documentos Vias
  {
    path: "listado/documentos-vias",
    loadChildren: () => import("../../components/pesv/vias-seguras-administradas/documentos-vias/documentos-vias.module").then((m) => m.DocumentosViasModule),
  },
  // Vias Zonas
  {
    path: "listado/vias-zonas",
    loadChildren: () => import("../../components/pesv/vias-seguras-administradas/vias-zonas/vias-zonas.module").then((m) => m.ViasZonasModule)
  },
  // Vias Riesgos (asociados a una zona puntual)
  {
    path: "listado/vias-zonas/riesgos/:id",
    loadChildren: () => import("../../components/pesv/vias-seguras-administradas/vias-zonas/vias-riesgos/vias-riesgos.module").then((m) => m.ViasRiesgosModule)
  },
   // Vias Inspecciones (asociadas a una zona puntual)
  {
    path: "listado/vias-zonas/inspecciones/:id",
    loadChildren: () => import("../../components/pesv/vias-seguras-administradas/vias-zonas/vias-inspecciones/vias-inspecciones.module").then((m) => m.ViasInspeccionesModule)
  },
  // Vias Hallazgos
  {
    path: "listado/vias-hallazgos/:id",
    loadChildren: () => import("../../components/pesv/vias-seguras-administradas/vias-hallazgos/vias-hallazgos.module").then((m) => m.ViasHallazgosModule)
  },
  // Rutas de desplazamientos
   {
    path: "listado/desplazamientos",
    loadChildren: () => import("../../components/pesv/planificacion-desplazamientos/desplazamientos/desplazamientos.module").then((m) => m.DesplazamientosModule),
   },
   // Rutas de puntos críticos
   {
    path: "listado/riesgos-desplazamientos/:id",
    loadChildren: () => import("../../components/pesv/planificacion-desplazamientos/riesgos-desplazamientos/riesgos-desplazamientos.module").then((m) => m.RiesgosDesplazamientosModule),
   },
   // Rutas de puntos críticos
   {
    path: "listado/puntos-criticos/:id",
    loadChildren: () => import("../../components/pesv/planificacion-desplazamientos/puntos-criticos/puntos-criticos.module").then((m) => m.PuntosCriticosModule),
   },
   // Rutas de requisitos de desplazamientos
   {
    path: "listado/requisitos-desplazamientos/:id",
    loadChildren: () => import("../../components/pesv/planificacion-desplazamientos/requisitos-desplazamientos/requisitos-desplazamientos.module").then((m) => m.RequisitosDesplazamientosModule),
   },
   // Rutas de seguimientos de desplazamientos
   {
    path: "listado/seguimientos-desplazamientos/:id",
    loadChildren: () => import("../../components/pesv/planificacion-desplazamientos/seguimientos-desplazamientos/seguimientos-desplazamientos.module").then((m) => m.SeguimientosDesplazamientosModule),
   },
   // Rutas de novedades de desplazamientos
   {
    path: "listado/novedades-desplazamientos/:id",
    loadChildren: () => import("../../components/pesv/planificacion-desplazamientos/novedades-desplazamientos/novedades-desplazamientos.module").then((m) => m.NovedadesDesplazamientosModule),
   },
   // Rutas de cierre de desplazamientos
   {
    path: "listado/cierre-desplazamientos/:id",
    loadChildren: () => import("../../components/pesv/planificacion-desplazamientos/cierre-desplazamientos/cierre-desplazamientos.module").then((m) => m.CierreDesplazamientosModule),
   },
   // Rutas de documentos de planificación de desplazamientos
   {
    path: "listado/documentos-planificacion",
    loadChildren: () => import("../../components/pesv/planificacion-desplazamientos/documentos-desplazamientos/documentos-desplazamientos.module").then((m) => m.DocumentosDesplazamientosModule),
   },
   // Rutas de documentos de gestión del cambio
   {
    path: "listado/documentos-gestion-cambio",
    loadChildren: () => import("../../components/pesv/cambio-gestion/documentos-gestion-cambio/documentos-gestion-cambio.module").then((m) => m.DocumentosGestionCambioModule),
   },
   // Rutas editar Retención
   {
    path: "editar-retencion/:id",
    loadChildren: () => import("../../components/pesv/archivo-retencion/editar-retencion/editar.module").then((m) => m.EditarModule),
   },
   // Rutas listado Retención
   {
    path: "listado/retencion",
    loadChildren: () => import("../../components/pesv/archivo-retencion/listado-retencion/listado-retencion.module").then((m) => m.ListadoRetencionModule),
   },
   // Rutas de registrar Retención
   {
    path: "registrar-retencion",
    loadChildren: () => import("../../components/pesv/archivo-retencion/registrar-retencion/registrar-retencion.module").then((m) => m.RegistrarRetencionModule),
   },
{
  path: 'configuracion-notificaciones',
  loadChildren: () =>
    import('../../components/notificaciones/configuracion-notificaciones/configuracion-notificaciones.module')
      .then(m => m.ConfiguracionNotificacionesModule)
},
{
    path: "mantenimientos-vehiculos",
    loadChildren: () => import("../../components/pesv/mantenimientos-vehiculos/mantenimientos-vehiculos.module").then((m) => m.MantenimientosVehiculosModule),
   // canActivate: [RolePermissionGuard],
    
  }
   
];
